import RichText from '@/components/RichText'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Card, CardContent } from '@/components/ui/card'
import React from 'react'

import FaqSection2 from './Faq2'
import FaqSections3 from './Faq3'

const FAQBlockEqualColumns = (props: any & { addSchema?: boolean }) => {
  const { questions, title, subtitle, type, image, customerCount, addSchema, images } = props

  // Helper function to extract plain text from richText for schema
  const extractTextContent = (content: any): string => {
    if (typeof content === 'string') return content
    if (content && typeof content === 'object' && content.root) {
      try {
        const extractText = (node: any): string => {
          if (typeof node === 'string') return node
          if (node?.text) return node.text
          if (node?.children) {
            return node.children.map(extractText).join('')
          }
          return ''
        }
        return extractText(content)
      } catch {
        return ''
      }
    }
    return ''
  }

  // Generate FAQPage JSON-LD schema
  const faqSchema = addSchema
    ? {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: questions?.map((item: any) => ({
          '@type': 'Question',
          name: extractTextContent(item.question),
          acceptedAnswer: {
            '@type': 'Answer',
            text: extractTextContent(item.answer),
          },
        })),
      }
    : null

  if (type === 'faq2')
    return (
      <FaqSection2
        questions={questions}
        title={title}
        customerCount={customerCount}
        addSchema={addSchema}
        images={images}
        subtitle={subtitle}
      />
    )
  if (type === 'faq3')
    return (
      <FaqSections3
        questions={questions}
        title={title}
        image={image}
        addSchema={addSchema}
        subtitle={subtitle}
      />
    )

  return (
    <main className="container mx-auto flex flex-col min-h-[50vh]" aria-label="FAQ">
      {addSchema && faqSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      )}
      {title && (
        <RichText
          className="text-center text-3xl md:text-4xl font-bold  mb-4"
          data={title}
          enableGutter={false}
          enableProse={true}
        />
      )}
      {subtitle && (
        <RichText
          className="text-center text-xl font-light text-muted-foreground mb-4"
          data={subtitle}
          enableGutter={false}
          enableProse={true}
        />
      )}
      <section aria-label="Frequently asked questions">
        <Accordion
          type="single"
          collapsible
          className="w-full grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          {questions?.map((item: any, index: any) => (
            <AccordionItem key={index} value={`item-${index}`} className="border-none">
              <Card className=" rounded">
                <AccordionTrigger
                  className="px-4 py-2  rounded-t-sm font-bold  text-base [font-family:'Open_Sans',Helvetica] leading-[17.6px] hover:underline"
                  asDiv={true}
                >
                  {item.question && (
                    <RichText
                      className=""
                      data={item.question}
                      enableGutter={false}
                      enableProse={true}
                    />
                  )}
                </AccordionTrigger>
                <AccordionContent>
                  <CardContent className="px-4 py-4 [font-family:'Open_Sans',Helvetica] font-normal text-muted-foreground text-base leading-[26px]">
                    {/* Example: Add internal anchor link to a service area page */}
                    {/* <a href="/services/fencing#dallas">Learn more about Dallas Fencing</a> */}
                    {item.answer && (
                      <RichText
                        className=""
                        data={item.answer}
                        enableGutter={false}
                        enableProse={true}
                      />
                    )}
                  </CardContent>
                </AccordionContent>
              </Card>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </main>
  )
}

export { FAQBlockEqualColumns }
